interface IConfig {
  appBaseUrl: string;
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
  cloudflareBaseUrl: string;
  cloudflareLocalizationUrl: string;
  cloudflareAssetsBaseUrl: string;
  termsAndConditionsUrl: string;
}

export const config: IConfig = {
  appBaseUrl: import.meta.env.VITE_APP_BASE_URL,
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  cloudflareBaseUrl: import.meta.env.VITE_CLOUDFLARE_BASE_URL,
  cloudflareLocalizationUrl: import.meta.env.VITE_CLOUDFLARE_LOCALIZATION_URL,
  cloudflareAssetsBaseUrl: import.meta.env.VITE_CLOUDFLARE_ASSETS_BASE_URL,
  termsAndConditionsUrl: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
};
